<template>
  <Row>
    <Row v-if="!userStore.token" class="w-32px h-32px rd-full header-round-hover-bg cursor-pointer" x="c" y="c">
      <IconSvg
        class="text-white! title font-20 transition pointer"
        name="icon-message"
        test-key="down-app"
        @click="() => toRouter({ path: '/login', query: { redirect: route.fullPath } })"
      />
    </Row>
    <el-dropdown
      v-if="userStore.token"
      id="downloadApp"
      class=""
      :hide-timeout="200"
      :popper-class="`dropdown-no-arrow el-popper-box-p-0 -m-l-20 message-menu-popper`"
      :teleported="true"
    >
      <Row v-openWin="'/mail'" class="position-r h-24 w-32px h-32px">
        <Row class="w-32px h-32px rd-full header-round-hover-bg cursor-pointer" x="c" y="c">
          <!-- <RedDot v-if="mailStore.unreadCount.allMessages" :position="true" class="position-a -top-5 -right-6 radius-50b" :num="mailStore.unreadCount.allMessages" /> -->
          <div v-if="mailStore.unreadCount.allMessages" class="position-a w-6 h-6 radius-50b top-0 right-6 bg-error" />
          <IconSvg class="text-white! title font-20 transition pointer" name="icon-message" test-key="down-app" />
        </Row>
      </Row>
      <template #dropdown>
        <Column class="message-menu-content w-330 h-460" y="c" x="c">
          <Row class="w-100b h-10" />
          <el-scrollbar
            class="w-100b"
            :height="376"
          >
            <Column v-if="mailStore.list?.length == 0" class="w-100b p-tb-140" x="c" y="c">
              <img class="w-60 h-68 " src="@/image/mail/no-data.webp">
              <span class="text-9b label m-t-16">{{ $t('public.emptyData2') }}</span>
            </Column>
            <Column
              v-for="(item) in mailStore.list"
              :key="item.id"
              class="p-lr-30 p-tb-12 position-r pointer"
              @click="mailRead(item)"
            >
              <span class="message-menu-date text-12px text-9b">{{ dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <Row class="label position-r m-tb-3 w-100b">
                <div v-if="item.readed == 0" class="position-a w-6 h-6 radius-50b -left-10 top-7 bg-error" />
                <span class="label w-100b ellipsis-2 text-16151A">{{ item.title }}</span>
              </Row>
              <span class="message-menu-description w-100b ellipsis text-12px text-9b">{{ item.content }}</span>
            </Column>
          </el-scrollbar>
          <Row class="w-100b h-10" />
          <Row class="message-menu-footer h-64 f-size-64 w-100b p-lr-20" y="c" x="sb">
            <Row>
              <Row class="message-menu-action pointer m-r-15" @click="() => diaMailSetData.show = true">
                <IconSvg class="message-menu-setting-icon m-r-6 icon" name="icon-icon_setting" />
                <span class="text-12px text-16151A">{{ $t("public.set") }}</span>
              </Row>
              <Row>
                <Row class="message-menu-action pointer" @click="readAll">
                  <IconSvg class="message-menu-read-icon m-r-6 icon" name="icon-yiduicon" />
                  <span class="text-12px text-16151A">{{ $t("mail.markallRead2") }}</span>
                </Row>
              </Row>
            </Row>
            <el-button v-openWin="'/mail'" class="message-menu-more" link>{{ $t('home.seeMore') }}</el-button>
          </Row>
        </Column>
      </template>
    </el-dropdown>
    <DiaMailSet v-model="diaMailSetData.show" />
  </Row>
</template>

<script setup>
import { getCurrentLocale, localizeUrl } from '@/utils/localeRoute.js'

const userStore = useUserStore()
const mailStore = useMailStore()
const route = useRoute()

const diaMailSetData = reactive({
  show: false
})

const readAll = async () => {
  const data = await mailApi.readAll({ })
  mailStore.getUnreadCount()
  mailStore.getList()
}

const mailRead = async (item) => {
  const locale = getCurrentLocale({
    path: route.path,
  })
  window.open(localizeUrl(`/mail?msgType=${item.msgType}&expandId=${item.id}`, locale))

  await mailStore.read(item)
  mailStore.getUnreadCount()
  mailStore.getList()
}
</script>

<style lang="scss">
.message-menu-popper.el-popper {
  border-radius: 12px;
  overflow: hidden;
}

.message-menu-footer {
  border-top: 1px solid var(--f4);
}

.message-menu-setting-icon,
.message-menu-read-icon {
  width: 16px;
  height: 16px;
  font-size: 16px;
}

.message-menu-setting-icon {
  color: var(--ccc);
}

.message-menu-read-icon {
  color: var(--ccc);
}

.message-menu-more.el-button {
  margin: 0;
  color: var(--16151A);
  font-size: 12px;
}
</style>
